export default __webpack_public_path__ + "static/media/KOD0057-min.28223af2.webp";